import { render, staticRenderFns } from "./integrationDocument.vue?vue&type=template&id=b180c64a&scoped=true"
import script from "./integrationDocument.vue?vue&type=script&lang=js"
export * from "./integrationDocument.vue?vue&type=script&lang=js"
import style0 from "./integrationDocument.vue?vue&type=style&index=0&id=b180c64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b180c64a",
  null
  
)

export default component.exports